import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login'
import Offline from './views/Offline'
import ForgotPassword from './views/ForgotPassword'
import Dashboard from './views/Dashboard'
import FinancialDashboard from './views/FinancialDashboard'
import MenuMobile from './components/MenuMobile'
import PermissionDenied from './views/403'
import NotFound from './views/NotFound'
import PdfViewer from './views/PdfViewer'
import StorageUtils from './utils/StorageUtils'
import http from './utils/Http'


Vue.use(Router);

const routes = [
    {
        path: '/login',
        name: 'login',
        component: Login
    }, {
        path: '*',
        name: 'notFound',
        component: NotFound
    }, {
        path: '/',
        name: 'root',
        redirect: {name: 'login'}
    }, {
        path: '/forgot_password',
        name: 'forgot_password',
        component: ForgotPassword
    }, {
        path: '/offline',
        name: 'offline',
        component: Offline
    }, {
        path: '/pdf-viewer',
        name: 'pdf_viewer',
        component: PdfViewer
    }, {
        path: '/logout',
        name: 'logout'
    }, {
        path: '/dashboard',
        name: 'dashboard',
        component: Dashboard,
        meta: {
            requiredAuth: true
        }
    }, {
        path: '/financial-dash',
        name: 'financial_dash',
        component: FinancialDashboard,
        meta: {
            requiredAuth: true,
            requireAnyProfiles: ['admin', 'admin_all', 'admin_view', 'backoffice']
        }
    }, {
        path: '/menu',
        name: 'menu',
        component: MenuMobile,
        meta: {
            requiredAuth: true,
        }
    }, {
        path: '/403',
        name: '403',
        component: PermissionDenied,
    }, {
        path: '/financial_movements',
        name: 'financial_movement',
        component: () => import(/* webpackChunkName: "financial-movements" */ `@/views/financial_movements/FinancialMovementsSearch`),
        meta: {
            requiredAuth: true,
            requireAnyProfiles: ['admin', 'admin_all', 'admin_view', 'backoffice']
        }
    }, {
        path: '/commission_payments',
        name: 'commission_payments',
        component: () => import(/* webpackChunkName: "commission-payments" */ `@/views/commission_payments/CommissionPaymentsSearch`),
        meta: {
            requiredAuth: true,
            requireAnyProfiles: ['admin', 'admin_all', 'admin_view']
        }
    }, {
        path: '/commission_payments/new',
        name: 'commission_payments_new',
        component: () => import(/* webpackChunkName: "commission-payments" */ `@/views/commission_payments/CommissionPaymentsEdit`),
        meta: {
            requiredAuth: true,
            requireAnyProfiles: ['admin', 'admin_all', 'admin_view']
        }
    }, {
        path: '/market_places',
        name: 'market_places',
        component: () => import(/* webpackChunkName: "market-places" */ `@/views/market_places/MarketPlacesSearch`),
        meta: {
            requiredAuth: true
        }
    }
];

let edit = () => import(/* webpackChunkName: "prod" */ `@/views/products/ProductsEdit`);

routes.push({
    path: '/products',
    name: 'products',
    component: () => import(/* webpackChunkName: "prod" */ `@/views/products/ProductsSearch`),
    meta: {
        requiredAuth: true,
        group: 'products'
    }
}, {
    path: '/products/new',
    name: 'productsNew',
    component: edit,
    meta: {
        requiredAuth: true,
        group: 'products'
    }
}, {
    path: '/products/:id/edit',
    name: 'productsEdit',
    component: edit,
    meta: {
        requiredAuth: true,
        group: 'products'
    }
});

edit = () => import(/* webpackChunkName: "prop" */ `@/views/proposals/ProposalsEdit`);

routes.push({
    path: '/proposals',
    name: 'proposals',
    component: () => import(/* webpackChunkName: "prop" */ `@/views/proposals/ProposalsSearch`),
    meta: {
        requiredAuth: true,
        group: 'proposals'
    }
}, {
    path: '/proposals/new',
    name: 'proposalsNew',
    component: edit,
    meta: {
        requiredAuth: true,
        group: 'proposals'
    }
}, {
    path: '/proposals/:id/edit',
    name: 'proposalsEdit',
    component: edit,
    meta: {
        requiredAuth: true,
        group: 'proposals'
    }
});


edit = () => import(/* webpackChunkName: "cust" */ `@/views/customers/CustomersEdit`);

routes.push({
    path: '/customers',
    name: 'customers',
    component: () => import(/* webpackChunkName: "cust" */ `@/views/customers/CustomersSearch`),
    meta: {
        requiredAuth: true,
        group: 'customers'
    }
}, {
    path: '/customers/new',
    name: 'customersNew',
    component: edit,
    meta: {
        requiredAuth: true,
        group: 'proposals'
    }
}, {
    path: '/customers/:id/edit',
    name: 'customersEdit',
    component: edit,
    meta: {
        requiredAuth: true,
        group: 'customers'
    }
});

edit = () => import(/* webpackChunkName: "inv" */ `@/views/invoices/InvoicesEdit`);

routes.push({
    path: '/invoices',
    name: 'invoices',
    component: () => import(/* webpackChunkName: "inv" */ `@/views/invoices/InvoicesSearch`),
    meta: {
        requiredAuth: true,
        group: 'invoices'
    }
}, {
    path: '/invoices/new',
    name: 'invoicesNew',
    component: edit,
    meta: {
        requiredAuth: true,
        group: 'invoices'
    }
}, {
    path: '/invoices/:id/edit',
    name: 'invoicesEdit',
    component: edit,
    meta: {
        requiredAuth: true,
        group: 'invoices'
    }
});

edit = () => import(/* webpackChunkName: "user" */ `@/views/users/UsersEdit`);

routes.push({
    path: '/users',
    name: 'users',
    component: () => import(/* webpackChunkName: "user" */ `@/views/users/UsersSearch`),
    meta: {
        requireAnyProfiles: ['admin', 'admin_all'],
        requiredAuth: true,
        group: 'users'
    }
}, {
    path: '/users/new',
    name: 'usersNew',
    component: edit,
    meta: {
        requireAnyProfiles: ['admin', 'admin_all'],
        requiredAuth: true,
        group: 'users'
    }
}, {
    path: '/users/:id/edit',
    name: 'usersEdit',
    component: edit,
    meta: {
        requireAnyProfiles: ['admin', 'admin_all'],
        requiredAuth: true,
        group: 'users'
    }
}, {
    path: '/users/profile',
    name: 'usersProfile',
    component: edit,
    meta: {
        requiredAuth: true,
        group: 'users'
    }
});


const broker_customers_wallets = 'broker_customers_wallets'
edit = () => import(/* webpackChunkName: "prod" */ `@/views/${broker_customers_wallets}/BrokerCustomersWalletsEdit`);
routes.push({
    path: '/' + broker_customers_wallets,
    name: broker_customers_wallets,
    component: () => import(/* webpackChunkName: "prod" */ `@/views/${broker_customers_wallets}/BrokerCustomersWalletsSearch`),
    meta: {
        requiredAuth: true,
        requireAnyProfiles: ['admin', 'admin_all', 'broker'],
        group: broker_customers_wallets
    }
}, {
    path: `/${broker_customers_wallets}/new`,
    name: `${broker_customers_wallets}_new`,
    component: edit,
    meta: {
        requiredAuth: true,
        requireAnyProfiles: ['admin', 'admin_all', 'broker'],
        group: broker_customers_wallets
    }
}, {
    path: `/${broker_customers_wallets}/:id/edit`,
    name: `${broker_customers_wallets}_edit`,
    component: edit,
    meta: {
        requiredAuth: true,
        requireAnyProfiles: ['admin', 'admin_all', 'broker'],
        group: broker_customers_wallets
    }
});

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: routes
});

router.beforeEach((to, from, next) => {
    const auth_token = StorageUtils.getAuthToken();

    if (to.matched.some(record => record.meta.requiredAuth)) {

        if (!auth_token) {
            next({
                path: '/login',
                query: {redirect: to.fullPath}
            })
        } else {
            if (to.meta.requireAnyProfiles) {
                if (!StorageUtils.userIsProfile(to.meta.requireAnyProfiles)) {
                    next({
                        path: '/403'
                    })
                } else {
                    next();
                }
            } else {
                next();
            }
        }
    } else if (to.name === 'login' && auth_token) {
        next({
            path: '/dashboard'
        });
    } else next();
});

// Heartbeat da tela atual para o assistente de IA (docs/mcp/16b-tempo-real.md).
// Só dispara se o usuário optou por compartilhar a tela — sem isso, o agente
// vê active=false. Best-effort: falha de rede nunca atrapalha a navegação.
router.afterEach((to) => {
    if (!StorageUtils.getAuthToken() || !StorageUtils.assistantSharesScreen()) return;

    const recordId = to.params && (to.params.id || to.params.token) || null;
    http.post('/v1/assistant/screen', {
        screen: to.meta && to.meta.group || to.name,
        record_id: recordId,
        title: typeof document !== 'undefined' ? document.title : null,
    }).catch(() => {});
});

export default router;
